
export function getStatus(cSlugname, cType, oStatItem) {

  if (oStatItem.stat_cslugname == cSlugname && oStatItem.stat_ctype == cType)
    return true;

  return false;
}

export const VERSION_STATUS = Object.freeze({
  WRITING: 1,
  REVIEW: 2,
  PUBLISHING: 3,
  PUBLISHED: 4,
  OBSOLETE: 8,
  TRASHED: 19,
});

export const DOCUMENT_STATUS = Object.freeze({
  ACTIVE: 20,
  ARCHIVED: 21,
});